/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Linkuseddescription3Inputs */

const en_signin_linkuseddescription3 = /** @type {(inputs: Signin_Linkuseddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in link has already been used. Each link can only be used once.`)
};

const fr_signin_linkuseddescription3 = /** @type {(inputs: Signin_Linkuseddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien de connexion a déjà été utilisé. Chaque lien ne peut être utilisé qu'une seule fois.`)
};

/**
* | output |
* | --- |
* | "This sign-in link has already been used. Each link can only be used once." |
*
* @param {Signin_Linkuseddescription3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_linkuseddescription3 = /** @type {((inputs?: Signin_Linkuseddescription3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Linkuseddescription3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_linkuseddescription3(inputs)
	return fr_signin_linkuseddescription3(inputs)
});
export { signin_linkuseddescription3 as "signIn_linkUsedDescription" }